// --------------------------------------------------------------
// Created On: 2023-08-14
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./RoleListRow.module.scss";

// A single role in a list of roles.
export default function RoleListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="role-list-row">
      <span>
        {props.name} {props.immutable && <span className={styles.tag}>Immutable</span>}
      </span>
    </div>
  );
}

interface Props {
  roleId: number;
  name: string;
  immutable: boolean;
}
